// native
import { Component, Input, OnInit, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs';

// service
import { ItemsDisplayService } from '../../../core/services/items-display.service';
import { NavigationService } from '../../../core/services/navigation.service';
import { ListService } from '../../../core/services/list.service';
import { CollectionsService } from '../../../core/services/collections.service';

// models
import { IList, ICollection, ListNode, ListCreationPayload } from '../../../models';

@Component({
  selector: 'navigation-list',
  templateUrl: './navigation-list.component.html',
  styleUrls: ['./navigation-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationListComponent implements OnInit {
  @Input()
  indent = 0;

  @Input()
  level = 0;

  @Input()
  maxDepth: number;

  @Input()
  collection: ICollection;

  @Input()
  node: ListNode;

  @Input()
  listExplorerMode?: boolean = false;

  @Input()
  canManage?: boolean = true;

  @Output()
  onCreateList: EventEmitter<ListCreationPayload> = new EventEmitter<ListCreationPayload>();

  loadingSource = new Subject<boolean>();

  loading$: Observable<boolean>;

  expanded = false;

  constructor(
    private itemsDisplayService: ItemsDisplayService,
    private navigationService: NavigationService,
    private listService: ListService,
    private collectionService: CollectionsService
  ) {
    this.loading$ = this.loadingSource.asObservable();
  }

  ngOnInit() {
    this.expanded = !!this.navigationService.isListExpanded(this.node.list.id);
  }

  onExpandedChange(isExpanded: boolean) {
    this.navigationService.setExpandedLists(this.node.list.id, isExpanded);
  }

  openListItems(id: string) {
    if (this.listExplorerMode) {
      this.onCreateList.emit({ collectionId: this.collection.id, parentListId: id });
      return;
    }

    this.itemsDisplayService.itemParams$.next({
      collection_id: this.collection.id,
      list_id: id
    });

    this.listService.currentList$.next(this.node.list);
    this.collectionService.currentLibrary$.next(this.collection);
  }

  listTrackByFn(index: number, list: IList) {
    return list.id;
  }
}
